import type { IconProps } from '@carboncopyco/icons';
import type React from 'react';
import { Button } from '../Button';
import { LoadingDots } from '../Loading';
import { Modal } from '../Modal';
import { Spacer } from '../Spacer';
import { TextBase } from '../Typography';

export interface ConfirmAlertProps {
  title: string;
  description?: string;
  yesLabel?: string;
  noLabel?: string;
  danger?: boolean;
  show: boolean;
  disabled?: boolean;
  yesIcon?: React.ReactElement<IconProps>;
  onConfirm: () => void;
  onClose: () => void;
  children?: React.ReactNode;
  containerClass?: string;
  noSecondButton?: boolean;
  loading?: boolean;
  zIndex?: number;
}

export const ConfirmAlert = ({
  title,
  description,
  yesLabel = 'Ok',
  noLabel = 'Cancel',
  yesIcon,
  danger,
  show,
  disabled,
  onConfirm,
  onClose,
  loading,
  children,
  containerClass,
  noSecondButton,
  zIndex,
}: ConfirmAlertProps) => {
  return (
    <Modal
      zIndex={zIndex}
      title={title}
      open={show}
      onClose={onClose}
      containerClass={containerClass}
    >
      <div className="flex flex-col">
        <div className="pt-4 pb-6">
          {description ? <TextBase label={description} /> : children}
        </div>
        {loading && (
          <div className="absolute bottom-6">
            <LoadingDots size={12} />
          </div>
        )}

        <div className="flex justify-end">
          {!noSecondButton && noLabel && (
            <>
              <Button
                secondary
                label={noLabel}
                link
                onClick={onClose}
              />
              <Spacer amount={0.375} />
            </>
          )}
          <Button
            danger={danger}
            label={yesLabel}
            disabled={disabled}
            leftIcon={yesIcon}
            onClick={onConfirm}
          />
        </div>
      </div>
    </Modal>
  );
};
